import React, { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert"; // Or use your own `MoreActionsIcon`

const ActionMenu = ({ addOffer, deleteOffer, isWithDeleteColumn }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    console.log("Clicked:", action);
    handleClose();
    // Add your logic here
    if (action === "add") {
      addOffer();
    } else if (action === "deleteCol") {
      // Supprime une colonne
    } else if (action === "deleteRow") {
      deleteOffer();
    }
  };

  return (
    <>
      <IconButton
        aria-controls={open ? "action-menu" : undefined}
        aria-haspopup="true"
        onClick={handleClick}>
        <MoreVertIcon /> {/* Replace with your MoreActionsIcon if needed */}
      </IconButton>

      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "action-button",
        }}>
        <MenuItem onClick={() => handleAction("add")}>
          Ajouter un article
        </MenuItem>
        {isWithDeleteColumn && (
          <MenuItem onClick={() => handleAction("deleteCol")}>
            Supprimer une colonne
          </MenuItem>
        )}
        <MenuItem onClick={() => handleAction("deleteRow")}>
          Supprimer une ligne
        </MenuItem>
      </Menu>
    </>
  );
};

export default ActionMenu;
